import { defineStore } from "pinia";

export type DirectoryTab = "teacher" | "parent" | "student" | "team" | "class";

export interface EntityData {
  entityType: DirectoryTab;
  entityId: string;
  entityName: string;
  entity: any;
}

export const useDirectoryNavigation = defineStore("directory/navigation", {
  state: () => ({
    activeTab: "teacher" as DirectoryTab,
    selectedEntity: null as EntityData | null,
    search: "",
    deleted: false,
    showSelectionMenu: false
  }),

  getters: {
    isEntitySelected: (state) => (entityType: DirectoryTab, entityId: string) => {
      return state.selectedEntity?.entityType === entityType && 
             state.selectedEntity?.entityId === entityId;
    }
  },

  actions: {
    setActiveTab(tab: DirectoryTab) {
      this.activeTab = tab;
    },

    setSearch(search: string) {
      this.search = search;
    },

    setDeleted(deleted: boolean) {
      this.deleted = deleted;
    },

    setShowSelectionMenu(show: boolean) {
      this.showSelectionMenu = show;
    },

    navigateToEntity(entityData: EntityData) {
      this.activeTab = entityData.entityType;
      this.selectedEntity = entityData;
      this.search = ""; // Clear search to show all entities
    },

    clearSelectedEntity() {
      this.selectedEntity = null;
    },

    reset() {
      this.activeTab = "teacher";
      this.selectedEntity = null;
      this.search = "";
      this.deleted = false;
      this.showSelectionMenu = false;
    }
  }
});

export default useDirectoryNavigation;
